import { render, staticRenderFns } from "./liveedit.vue?vue&type=template&id=5a55514c&scoped=true&"
import script from "./liveedit.vue?vue&type=script&lang=js&"
export * from "./liveedit.vue?vue&type=script&lang=js&"
import style0 from "./liveedit.vue?vue&type=style&index=0&id=5a55514c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55514c",
  null
  
)

export default component.exports